<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="500">
    <v-card>
      <v-card-title class="text-h5">
        {{ title }}
      </v-card-title>

      <v-card-text v-html="text"></v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="cancelText" text @click="cancel()"> {{ cancelText }}</v-btn>
        <v-btn v-if="okText" text @click.stop="ok()">
          {{ okText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CommonDialog',
  props: {
    id: String,
    value: Boolean,
    title: String,
    text: String,
    cancelText: String,
    okText: String,
    params: Object,
  },
  data() {
    return {
      shadowValue: this.value,
    };
  },

  methods: {
    cancel() {
      this.shadowValue = false;
      this.$emit('input', false);
      this.$emit('onCancel', this.id, this.params ? this.params : {});
    },
    ok() {
      console.log('close commonDialog');
      this.$emit('input', false);
      this.$emit('onOk', this.id, this.params ? this.params : {});
    },
  },
};
</script>
